import React, { useState, useRef } from "react";
import { Button, Input } from "antd";
import "./login.css";
import { EyeInvisibleOutlined, EyeTwoTone } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { ErrorToast, SuccessToast } from "../../widgets/AppToast";
import { post } from "../../services/services";
import { ApiURL } from "../../services/apiConstants";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loader, setLoader] = useState(false);
  const [errors, setErrors] = useState({});
  const loginButtonRef = useRef(null);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      loginButtonRef.current.click();
    }
  };

  const login = async () => {
    if (loader) return;
    setLoader(true);
    try {
      const formData = new FormData();
      formData.append("email", email);
      formData.append("password", password);
      const res = await post(ApiURL.login, formData);
      if (res?.status === true) {
        const { login_token, refresh_token, role } = res?.data;
        localStorage.setItem("user_data", JSON.stringify(res));
        // localStorage.setItem("login_token", login_token);
        // localStorage.setItem("refresh_token", refresh_token);
        localStorage.setItem("role", role);
        SuccessToast("Success message!!", res?.message);
        window.location = "/";
      } else {
        setErrors(res?.errors || {});
        ErrorToast(
          "Login Error",
          res?.message || "Both email and password are required"
        );
      }
    } catch (error) {
      ErrorToast("Login error", "An error occurred during login!");
    } finally {
      setLoader(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-box-head">
          <h5>MarinBytes - Admin Portal</h5>
          <h2>Login</h2>
        </div>
        <div className="login-box-body">
          <div className="input-box">
            <Input
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="off"
              onKeyDown={handleKeyDown}
            />
            {errors?.email && (
              <span style={{ color: "red" }}>{errors.email}</span>
            )}
          </div>
          <div className="input-box">
            <Input.Password
              placeholder="password"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onKeyDown={handleKeyDown}
              iconRender={(visible) =>
                visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />
              }
            />
            {errors?.password && (
              <span style={{ color: "red" }}>{errors.password}</span>
            )}
          </div>

          <div className="input-box" style={{ textAlign: "left" }}>
            <Button
              className="save_btn_l"
              type="primary"
              onClick={login}
              loading={loader}
              ref={loginButtonRef}
            >
              Login
            </Button>
            <span
              style={{
                float: "right",
                cursor: "pointer",
                fontSize: "15px",
                marginTop: "5px",
              }}
              onClick={() => navigate("/set-new-password")}
            >
              Forgot Password
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
